import Banner from 'components/Banner';
import GradientText from 'components/GradientText';
import NewsCards from 'components/NewsCards';
import TagsFilter from 'components/TagsFilter';
import './styles.scss';
import { Button } from 'components/buttons/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBlog, selectBlogPage } from 'store/slices/BlogSlice';
import { useEffect } from 'react';
import React from 'react';

// TODO NOT DONE
const News = () => {
    const dispatch = useDispatch();
    const {
        title,
        description,
        posts = [], // TODO get post from posts list
        tags,
        title_background,
        subscribe_title,
        subscribe_description,
        subscribe_policy_text,
        show_all_button,
        // TODO recheck all field and add
    } = useSelector(selectBlogPage);

    useEffect(() => {
        setSelectedTag(show_all_button);
        // @ts-ignore
        dispatch(fetchBlog());
    }, [dispatch, show_all_button]);

    const [selectedTag, setSelectedTag] = React.useState('');
    const handleClick = name => setSelectedTag(name);

    const filteredPosts = selectedTag === show_all_button ? posts : posts.filter(post => post.type === selectedTag);

    return (
        <>
            <Banner title={title} image={title_background} buttonText="!! field_name ? " />

            <section className="container">
                <div className="inner-container">
                    <div className="news-heading">
                        <GradientText size="small">
                            <div className="max-width-760">
                                <span dangerouslySetInnerHTML={{ __html: description }} />
                            </div>
                        </GradientText>
                        <TagsFilter
                            showAllName={show_all_button}
                            tags={tags}
                            selectedTag={selectedTag}
                            onClick={handleClick}
                        />
                    </div>
                    <NewsCards
                        posts={filteredPosts}
                        subscribeTitle={subscribe_title}
                        subscribeDescription={subscribe_description}
                        subscribePolicy={subscribe_policy_text}
                    />
                    {/* <Button type="show-more" className="full-width">
                        SHOW MORE
                    </Button> */}
                </div>
            </section>
        </>
    );
};

export default News;
